var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeLocatinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6843_45610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55859 0.683838C9.80078 0.44165 10.1992 0.44165 10.4414 0.683838L13.5664 3.80884C13.6641 3.90649 13.7266 4.0354 13.7461 4.17212L15.3164 16.7502H4.68359L6.25391 4.17212C6.26953 4.0354 6.33203 3.90649 6.43359 3.80884L9.55859 0.683838ZM8.4375 11.1252C7.91797 11.1252 7.5 11.5432 7.5 12.0627C7.5 12.5823 7.91797 13.0002 8.4375 13.0002H11.5625C12.082 13.0002 12.5 12.5823 12.5 12.0627C12.5 11.5432 12.082 11.1252 11.5625 11.1252H8.4375ZM3.75 18.0002H16.25C16.9414 18.0002 17.5 18.5588 17.5 19.2502C17.5 19.9417 16.9414 20.5002 16.25 20.5002H3.75C3.05859 20.5002 2.5 19.9417 2.5 19.2502C2.5 18.5588 3.05859 18.0002 3.75 18.0002Z",
    fill: "#1C3D5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6843_45610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeLocatinIcon);
export default __webpack_public_path__ + "static/media/type-locatin-icon.2d497888c110746acfeaf001f2374c45.svg";
export { ForwardRef as ReactComponent };